import Avvvatars from "avvvatars-react";
import { Link } from "react-router-dom";
import { parent_routes } from "../../../router/all_routes";
import { useAcademicYear } from "../../../../core/common/context/AcademicYearContext";
import { getStudentCourseByYear } from "../../../../api/edt";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { useChildrenDetails } from "../../../../core/common/context/ChildrenDetailsContext";
import { ExtendHeaderPageComponent } from "../parentDashBoard";
import NoRegistratedAlert from "../noRegistratedAlert";

const StudentCourse = () => {
  const routes = parent_routes;
  const { childrenDetails, selectedChild, setSelectedChild } =
    useChildrenDetails();
  const [selectedChildInfos, setSelectedChildInfos] = useState<any>();

  const { selectedYear } = useAcademicYear();

  //Initialisation des state utilisés
  const [allCourses, setAllCourses] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // Pour le vrai chargement
  const [hasLoaded, setHasLoaded] = useState(false); // Pour éviter "Chargement..." quand il n'y a juste pas de données

  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    // On attend que selectedYear soit défini
    if (!selectedYear?.id || !selectedChildInfos) return;
    const fetchCourses = async () => {
      try {
        const response = await getStudentCourseByYear(
          selectedChildInfos?.class?.id,
          selectedChild,
        );
        const courses = response.data || [];

        setAllCourses(courses);

        // console.log("Courses", response);
      } catch (error: any) {
        // console.log("erreur de chargement des Cours : ", error);
        toast.error(
          error.response?.data?.message ||
            error.response?.data?.error ||
            error.message ||
            "Une erreur s'est produit, Réessayer plus tard",
        );

        // Option: reset les salles en cas d'erreur
        setAllCourses([]);
      } finally {
        setIsLoading(false); //Les données ne sont plus en chargement
        setHasLoaded(true); //Les données ont été chargé avec succès
      }
    };
    if (selectedChildInfos?.academicYear?.id !== selectedYear?.id) return;
    fetchCourses();
  }, [refreshKey, selectedYear, selectedChildInfos]);

  // charger les informations detwilles de l'enfant selectionner
  useEffect(() => {
    const matchedChild = childrenDetails.find(
      (c: any) => c.id === selectedChild,
    );
    // console.log("Matched !: ", matchedChild);
    if (matchedChild) setSelectedChildInfos(matchedChild);
  }, [selectedChild, childrenDetails]);

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("fr-FR", {
      month: "short",
      year: "numeric",
    })
      .format(date)
      .replace(/^\w/, (c) => c.toUpperCase()); // Mettre la 1ère lettre en majuscule
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Mes cours</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    {" "}
                    <Link to={routes.parentDashboard}>Accueil</Link>
                  </li>
                  <li className="breadcrumb-item">
                    {selectedChildInfos?.class?.Level?.abbreviation}{" "}
                    {selectedChildInfos?.class?.label}
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Cours
                  </li>
                </ol>
              </nav>
            </div>
            <ExtendHeaderPageComponent
              childrenDetails={childrenDetails}
              activeStudent={selectedChild}
              setSelectedChild={setSelectedChild}
              handleClick={(selectedChild: any) =>
                setSelectedChild(selectedChild)
              }
            />
          </div>
          {/* /Page Header */}

          <div className="row">
            <div className="col-md-12">
              <div className="row">
                {/* Blog List */}
                {selectedChildInfos?.academicYear?.id !== selectedYear?.id ? (
                  <NoRegistratedAlert />
                ) : allCourses.length > 0 ? (
                  allCourses.map((course: any, index) => (
                    <div className="col-md-6">
                      <div className="card mb-1">
                        <div className="card-body p-3 pb-1">
                          <div className="d-flex align-items-center justify-content-between flex-wrap">
                            <div className="overflow-hidden">
                              <ul className="d-flex align-items-center flex-wrap row-gap-2">
                                {/* <li className="pe-2 me-2 border-end">
                                                <i className="ti ti-calendar me-1" />
                                                {formatDate(course.createdAt)}
                                            </li> */}
                                <li className="d-flex align-items-center pe-2 me-2 border-end">
                                  <span className="avatar avatar-xs me-1">
                                    <Avvvatars
                                      value={`${
                                        course.TeacherProfil.firstname?.charAt(
                                          0,
                                        ) || ""
                                      }${
                                        course.TeacherProfil.lastname?.charAt(
                                          0,
                                        ) || ""
                                      }`}
                                      style="character" // ou "character"
                                      size={20}
                                    />
                                  </span>
                                  {course.TeacherProfil.firstname}{" "}
                                  {course.TeacherProfil.lastname}
                                </li>
                                <li className="pe-2">
                                  {course.state === "Approuvé" ? (
                                    <span className="badge badge-soft-success d-inline-flex align-items-center me-2">
                                      <i className="ti ti-circle-filled fs-6 me-1" />
                                      Approuvé
                                    </span>
                                  ) : (
                                    <span className="badge badge-soft-warning d-inline-flex align-items-center me-2">
                                      <i className="ti ti-circle-filled fs-6 me-1" />
                                      Non Approuvé
                                    </span>
                                  )}
                                </li>
                              </ul>
                              <h5 className=" my-3">
                                <Link to={`/course/${course?.id}`}>
                                  {course.Subject.label}
                                </Link>
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="col-12">
                    <div className="card shadow-sm text-center p-5 border-0">
                      <div className="mb-3">
                        <i className="ti ti-inbox fs-1 text-muted" />
                      </div>
                      <h5 className="text-muted">Aucun cours disponible</h5>
                      <p className="text-muted mb-0">
                        Les cours que vous créez ou qui vous sont attribués
                        apparaîtront ici.
                      </p>
                    </div>
                  </div>
                )}

                {/* /Blog List */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentCourse;
